
import { StripeElements, StripeElement } from "vue-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { defineComponent, ref, onBeforeMount, onMounted, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";

export default defineComponent({
  name: "new-card-modal",
  components: {
    StripeElements,
    StripeElement,
  },
  setup() {
    const loading = ref<boolean>(false);
    const store = useStore();
    const cards = computed(() => store.getters.cardsGetter);
    onBeforeMount(() => {
      const stripePromise = loadStripe(stripeKey.value);
      stripePromise.then(() => {
        stripeLoaded.value = true;
      });
    });
    const stripeKey = ref(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    const stripeLoaded = ref(false);
    const cardNumber = ref();
    const cardExpiry = ref();
    const cardCvc = ref();
    const postalCode = ref();
    const elms = ref();
    const instanceOptions = ref({});
    const elementsOptions = ref({});
    const cardOptions = ref({
      value: {
        // postalCode: "12345",
      },
    });
    const submitButtonRef = ref<null | HTMLButtonElement>(null);
    const newCardModalRef = ref<null | HTMLElement>(null);
    const setupIntent = ref<string>("");
    const getSetupIntent = async () => {
      try {
        const response = await store.dispatch(Actions.SETUP_INTENT);
        if (!response.success) throw new Error("");
        setupIntent.value = response?.data?.client_secret ?? "";
      } catch (err) {
        //
      }
    };
    const clear = () => {
      cardNumber.value?.stripeElement?.clear();
      cardExpiry.value?.stripeElement?.clear();
      cardCvc.value?.stripeElement?.clear();
      postalCode.value?.stripeElement?.clear();
    };
    const getCards = () => {
      return new Promise((resolve, reject) => {
        store.dispatch(Actions.GET_CARDS)
        .then(() => resolve(""))
        .catch(() => reject(""))
      });
    };
    onMounted(async () => {
      getCards();
      getSetupIntent();
    });
    return {
      loading,
      clear,
      submitButtonRef,
      newCardModalRef,
      stripeKey,
      stripeLoaded,
      instanceOptions,
      elementsOptions,
      cardOptions,
      cardNumber,
      postalCode,
      cardExpiry,
      cardCvc,
      elms,
      store,
      getSetupIntent,
      setupIntent,
      getCards,
      cards,
    };
  },
  methods: {
    async changeActiveCard(id) {
      try {
        const response = await this.store.dispatch(
          Actions.CHANGE_ACTIVE_CARD_STATUS,
          {
            cardId: id,
            status: 1,
          }
        );
        if (!response?.success) throw new Error("error in active card status");
        this.getCards();
        this.$emit("subscribe", true)
      } catch (err) {
        //
      }
    },
    async addPaymentMethod() {
      this.loading = true;
      const cardElement = this.cardNumber.stripeElement;
      try {
        const response = await this.elms.instance.handleCardSetup(
          this.setupIntent,
          cardElement,
          {}
        );
        console.log({ response });
        if (response?.error) {
          this.getSetupIntent();
          throw new Error(response?.error?.message);
        }
        const saveCardResponse = await this.store.dispatch(Actions.SAVE_CARD, {
          paymentMethod: response?.setupIntent?.payment_method,
        });
        if (saveCardResponse !== true)
          throw new Error("error in saving card details!");
        this.getSetupIntent();
        this.cardNumber.stripeElement?.clear();
        this.cardExpiry.stripeElement?.clear();
        this.cardCvc.stripeElement?.clear();
        this.postalCode.stripeElement?.clear();
        this.loading = false;
        hideModal(this.newCardModalRef);
        this.store.commit("setAlert", {
          message: "Success",
          subMessage: "Payment Method Added!",
          variant: "primary",
          duration: 4000,
          show: true,
        });
        await this.getCards();
        if (this.cards?.length == 1) {
          this.changeActiveCard(this.cards?.[0]?.id);
        }
      } catch (err) {
        this.loading = false;
        hideModal(this.newCardModalRef);
        this.store.commit("setAlert", {
          message: "Error",
          subMessage: err,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    },
  },
});
